var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-group', {
    attrs: {
      "id": `${_vm.id}-group`,
      "label": _vm.required ? `${_vm.label} ${_vm.$t('form.required')}` : _vm.label,
      "label-for": `${_vm.id}-field`
    }
  }, [_c('b-form-select', {
    staticClass: "selector w-100",
    attrs: {
      "id": `${_vm.id}-field`,
      "state": _vm.state,
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.selectedValue,
      callback: function ($$v) {
        _vm.selectedValue = $$v;
      },
      expression: "selectedValue"
    }
  }, [_vm.defaultValue ? _c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.defaultValue)) + " ")]) : _vm._e(), _vm.hasEmptyOption || _vm.emptyOptionText ? _c('option', {
    attrs: {
      "disabled": !_vm.hasEmptyOption
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(" " + _vm._s(_vm.emptyOptionText) + " ")]) : _vm._e(), _vm._l(_vm.options, function (option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(" " + _vm._s(option.name) + " ")]);
  })], 2), _vm._t("validation-messages")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }